import request from "@/utils/request";

export function getGrcRisks(params) {
  return request({
    url: "/grc-risks",
    method: "get",
    params,
  });
}

export function getGrcRisk(id, params) {
  return request({
    url: `/grc-risks/${id}`,
    method: "get",
    params,
  });
}

export function createGrcRisk(data, params) {
  return request({
    url: "/grc-risks",
    method: "post",
    data,
    params,
  });
}

export function updateGrcRisk(id, data, params) {
  return request({
    url: `/grc-risks/${id}`,
    method: "put",
    data,
    params,
  });
}

export function approveGrcRisk(id, data, params) {
  return request({
    url: `/grc-risks/${id}/approve`,
    method: "post",
    data,
    params,
  });
}

export function rejectGrcRisk(id, data, params) {
  return request({
    url: `/grc-risks/${id}/reject`,
    method: "post",
    data,
    params,
  });
}

export function deleteGrcRisk(id, params) {
  return request({
    url: `/grc-risks/${id}`,
    method: "delete",
    params,
  });
}
